export default "__VITE_ASSET__BcUesN43__"